module.exports = __webpack_public_path__ + "img/ico-chevron-down.80b88509.svg";